"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Groups = void 0;
const client_1 = require("@arkecosystem/client");
class Groups extends client_1.Resource {
    async index(query) {
        return this.sendGet("guardian/groups", query);
    }
    async get(groupName) {
        return this.sendGet(`guardian/groups/${groupName}`);
    }
    async users(groupName) {
        return this.sendGet(`guardian/groups/${groupName}/users`);
    }
}
exports.Groups = Groups;
//# sourceMappingURL=groups.js.map